















import Vue from "vue";

// Routing
import * as routes from "@/router/routes";

// Vuex
import { mapMutations, mapState } from "vuex";
import { OPEN_DEVICE_TREE_TO_FOLDER_ID } from "@/store/modules/ApplicationModule/mutations";

// Model
import { findParentNodesFromInstallationName } from "@/utility/TreeviewUtility";

export default Vue.extend({
    data() {
        return {
            routes,
            items: [],
        };
    },
    props: {
        installationName: { type: String, required: true },
        showInstallationName: { type: Boolean, required: false, default: true },
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),
    },
    watch: {
        installationName() {
            this.getInstallationTreePath();
        },
    },
    methods: {
        ...mapMutations([OPEN_DEVICE_TREE_TO_FOLDER_ID]),

        getInstallationTreePath() {
            this.items = [];
            let parentNodes = findParentNodesFromInstallationName(this.deviceTree, this.installationName);
            parentNodes.forEach((parentNode) => {
                this.items.push({
                    text: parentNode.name,
                    folderId: parentNode.id,
                });
            });
        },

        onFolderClick(folderId) {
            this[OPEN_DEVICE_TREE_TO_FOLDER_ID](folderId);
        },
    },
    mounted() {
        this.getInstallationTreePath();
    },
});
